<template>
  <div class="existing-account-argument">
    <span><img :src="require('@/assets/' + image + '.svg')" alt /></span>
    <div>
      <h2>{{ title }}</h2>
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'existing-account-argument',
  props: {
    image: String,
    title: String,
    text: String
  }
}
</script>

<style lang="scss">
.existing-account-argument {
  display: flex;
  text-align: left;

  & > span {
    width: 40px;
    min-width: 40px;
    height: 40px;
    background-color: #8D62FF;
    padding: 10px;
    border-radius: 100%;
    margin-right: 12px;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  & > div {
    color: #6A6370;

    & > h2 {
      margin: 0;
      font-size: 14px;
      font-weight: 900;
    }

    & > p {
      margin: 0;
      font-size: 12px;
      line-height: 1.4;
      font-weight: normal;
    }
  }

  @media only screen and (min-width: 470px) {
    & > span {
      width: 50px;
      min-width: 50px;
      height: 50px;
      padding: 12px;
      margin-right: 12px;
    }
  }

  @media only screen and (min-width: 1200px) {
    & > span {
      width: 65px;
      min-width: 65px;
      height: 65px;
      padding: 15px;
      margin-right: 20px;
    }

    & > div {
      & > h2 {
        font-size: 20px;
      }

      & > p {
        font-size: 16px;
      }
    }
  }
}
</style>
